/* jshint esversion: 6 */
/* jshint esversion: 11 */
/* jshint ignore:start */
import { useContext, useEffect, useState } from 'react';
import { FaStar } from 'react-icons/fa';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import { LuChevronRight, LuPlus, LuWallet } from 'react-icons/lu';
import { Link, useLocation } from 'react-router-dom';
import { MyContext } from '../../Context/MyProvider';
import axios from 'axios';
import { showToast } from '../../showTost';
import Payment from '../../Payment/Payment';
import BookingDetails from './BookingDetails';
import AddPatient from './AddPatient';
import { IoCheckmark } from 'react-icons/io5';
import { useTranslation } from 'react-i18next';
import Loading from '../Loading';
import secureLocalStorage from "react-secure-storage";
import ImageLoad from '../ImageLoad';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';

const SectionLabel = ({ label }) => (
  <div className="flex items-center gap-2 mb-3">
    <span className="w-1 h-5 bg-indigo-600 rounded-full block" />
    <h2 className="text-base font-bold text-slate-800">{label}</h2>
  </div>
);

const PriceRow = ({ label, value, accent, bold }) => (
  <div className="flex items-center justify-between py-2 border-b border-slate-50 last:border-0">
    <span className={`text-sm ${bold ? "font-bold text-slate-800" : "text-slate-500"}`}>{label}</span>
    <span className={`text-sm font-bold ${accent ? "text-indigo-600" : bold ? "text-slate-800" : "text-slate-700"}`}>{value}</span>
  </div>
);

const Bookappoinment = () => {

  const { t } = useTranslation();
  const { ApiBaseUrl, ImgBaseUrl, isPayment, setIsPayment, paymentStatus, patientStatus, setPaymentStatus, transactionid } = useContext(MyContext);
  const site_currency = secureLocalStorage.getItem("currency");
  const currency = site_currency ? site_currency : "$";

  const [loading, setLoading] = useState(true);
  const [isDriverSelected, setIsDriverSelected] = useState(false);
  const [relationshipData, setRelationshipData] = useState([]);
  const [booldData, setBooldData] = useState([]);
  const [isPatient, setIsPatient] = useState(false);
  const [selectPatient, setSelectPatient] = useState([0]);
  const [couponList, setCouponList] = useState([]);
  const [isCouponShow, setIsCouponShow] = useState(false);
  const [docProfileData, setDocProfileData] = useState();
  const [departmentData, setDepartmentData] = useState();
  const [hospitalName, setHospitalName] = useState();
  const [familyData, setFamilyData] = useState([]);
  const [couponCode, setCouponCode] = useState();
  const [totalAmt, setTotalAmt] = useState();
  const [totalAmt2, setTotalAmt2] = useState();
  const [commissionData, setCommissionData] = useState();
  const [tax, setTax] = useState();
  const [taxType, setTaxType] = useState();
  const [charges, setCharges] = useState();
  const [serviceTotal, setServiceTotal] = useState();
  const [extraPatientCharges, setExtraPatientCharges] = useState();
  const [additionalNote, setAdditionalNote] = useState();
  const [bookingData, setBookingData] = useState();
  const [isBooking, setIsBooking] = useState(false);
  const [myWallet, setMyWallet] = useState();
  const [myWallet2, setMyWallet2] = useState();
  const [wallet, setWallet] = useState();
  const [allData, setAllData] = useState();

  const Location = useLocation();
  const stateData = Location.state?.data;
  if (stateData) {
    try {
      sessionStorage.setItem("CurrentBookData", JSON.stringify(stateData));
    } catch(e) {}
  }
  let sessionData = null;
  try {
    sessionData = JSON.parse(sessionStorage.getItem("CurrentBookData") || "null");
  } catch(e) {}
  const Daata = stateData || sessionData || {};
  const abc = Daata?.Date ? new Date(Daata.Date) : new Date();
  const dateStr = abc.toDateString();
  const split = dateStr.split(" ");

  const toggleDriverSelection = () => setIsDriverSelected(prev => !prev);

  useEffect(() => {
    window.scrollTo(0, 0);
    HandleFetchData();
    axios.get(`${ApiBaseUrl}/customer/family_member_add_detail`)
      .then((res) => {
        const { relationship_list, blood_group_list } = res.data;
        setRelationshipData(relationship_list);
        setBooldData(blood_group_list);
      })
      .catch((error) => { console.error(error); });
    setServiceTotal(Daata?.showtypeprice || 0);
    const totalcharg = ((Daata?.showtypeprice || 0) * (Daata?.commission || 0)) / 100;
    setCharges(totalcharg.toFixed(2));
  }, []);

  useEffect(() => {
    if (!commissionData) return;
    if (commissionData.commission_type === "fix") {
      setTax(commissionData.commission);
      setTaxType(commissionData.commission_type);
    } else {
      const totalTax = (Daata?.showtypeprice || 0) * (commissionData.commission / 100);
      setTax(totalTax.toFixed(2));
      setTaxType(commissionData.commission + commissionData.commission_type);
    }
  }, [commissionData]);

  useEffect(() => {
    const extraPrice = selectPatient.length >= 2 ? (selectPatient.length - 1) * (Number(extraPatientCharges) || 0) : 0;
    const baseTotal = Number(serviceTotal || 0) + Number(tax || 0) + extraPrice;
    const finalTotal = couponCode ? Math.max(0, baseTotal - couponCode.amt) : baseTotal;
    setTotalAmt(finalTotal);
    setTotalAmt2(baseTotal);
  }, [serviceTotal, tax, selectPatient, extraPatientCharges, couponCode]);

  useEffect(() => {
    let adjustedTotal = totalAmt2;
    if (couponCode) { adjustedTotal -= couponCode.amt; }
    const isWalletSufficient = myWallet > totalAmt;
    if (isWalletSufficient) {
      if (isDriverSelected) {
        setTotalAmt(0); setWallet(adjustedTotal); setMyWallet2((myWallet - totalAmt).toFixed(2));
      } else {
        setTotalAmt(adjustedTotal); setWallet(0); setMyWallet2(myWallet);
      }
    } else {
      if (isDriverSelected) {
        setTotalAmt(totalAmt - myWallet); setWallet(myWallet); setMyWallet2(0);
      } else {
        setTotalAmt(adjustedTotal); setWallet(0); setMyWallet2(myWallet);
      }
    }
  }, [isDriverSelected]);

  const SelectPatientHandle = (index) => {
    if (isDriverSelected) { setIsDriverSelected(false); }
    if (selectPatient.includes(index)) {
      if (selectPatient.length === 1) {
        showToast({ title: t("At least one patient must be selected"), id: "info" });
        return;
      }
      setSelectPatient(selectPatient.filter((id) => id !== index));
    } else {
      setSelectPatient([...selectPatient, index]);
    }
  };

  useEffect(() => {
    HandleFetchData();
    setIsPatient(false);
  }, [patientStatus]);

  const HandleFetchData = () => {
    const UserId = secureLocalStorage.getItem("Userid");
    if (UserId && Daata?.Docid) {
      const Data = { id: UserId, d_id: Daata?.Docid, sub_depar_id: Daata?.subdeparid, hospital_id: Daata?.HospitalId };
      axios.post(`${ApiBaseUrl}/customer/cart_data`, Data)
        .then((res) => {
          const { ResponseCode, coupon, doctor, dep_sub_ser_list, hospital, family_member, commission_data, extra_doctor_charge, wallet_amount } = res.data;
          if (ResponseCode === 200) {
            setLoading(false);
            setMyWallet(wallet_amount ? Number(wallet_amount).toFixed(2) : "0.00");
            setCouponList(coupon || []);
            setDocProfileData(doctor);
            setDepartmentData(dep_sub_ser_list);
            setHospitalName(hospital);
            setFamilyData(family_member || []);
            const selectedId = family_member?.[0]?.id;
            setSelectPatient(selectedId ? [selectedId] : ["0"]);
            setCommissionData(commission_data);
            setExtraPatientCharges(extra_doctor_charge || 0);
          }
        })
        .catch((error) => { console.error(error); setLoading(false); });
    } else {
      setLoading(false);
    }
  };

  const HandleCoupanAdd = (code, amt, id) => {
    setCouponCode({ code, amt, id });
    showToast({ title: t("Coupon Add Successful"), id: "success" });
    setIsCouponShow(false);
  };

  const HandleCoupanRemove = () => {
    if (couponCode) { setCouponCode(""); } else { setIsCouponShow(true); }
    if (isDriverSelected) { setIsDriverSelected(!isDriverSelected); }
  };

  const HandleProceed = () => {
    if (selectPatient.length <= 0) { showToast({ title: t("Please Select Patient"), id: "error" }); return; }
    if (isDriverSelected && totalAmt === 0) {
      HandleBookAppointment();
    } else {
      setIsPayment(true);
      const Userid = secureLocalStorage.getItem("Userid");
      if (Userid) {
        const additionalPrice = selectPatient.length >= 2 && (selectPatient.length - 1) * extraPatientCharges;
        const TotalPrice = couponCode ? totalAmt2 - couponCode.amt : totalAmt2;
        const Data = {
          id: String(Userid),
          d_id: Daata?.Docid || docProfileData?.id || "23",
          sub_depar_id: Daata?.subdeparid || departmentData?.id || "106",
          hospital_id: Daata?.HospitalId || hospitalName?.id || departmentData?.hospital_id || "10",
          department_id: Daata?.DepartmentId || departmentData?.department_id || "18",
          date: Daata?.Date || new Date().toISOString().split("T")[0],
          date_type: Daata?.datetype || "Morning",
          time: Daata?.time || "10:00 AM",
          family_mem_id: selectPatient && selectPatient.length > 0 ? selectPatient : (familyData?.[0]?.id ? [familyData[0].id] : ["0"]),
          show_type: Daata?.show_type || "1",
          show_type_price: Daata?.showtypeprice || serviceTotal || "0",
          tot_price: TotalPrice,
          additional_price: additionalPrice ? String(additionalPrice) : "0",
          coupon_id: couponCode ? String(couponCode.id) : "0",
          coupon_amount: couponCode ? String(couponCode.amt) : "0",
          doctor_commission: Daata?.commission || "0",
          site_commisiion: tax || "0",
          wallet_amount: isDriverSelected ? String(totalAmt2 - totalAmt) : "0",
          additional_note: additionalNote ? additionalNote : ""
        };
        setAllData(Data);
        sessionStorage.setItem("page", "1");
      }
    }
  };

  useEffect(() => {
    if (!paymentStatus) return;
    if (paymentStatus === "PaymentDone") {
      HandleBookAppointment(); setIsPayment(false); setPaymentStatus("");
    } else {
      setIsPayment(false); setPaymentStatus("");
    }
  }, [paymentStatus]);

  const HandleBookAppointment = () => {
    const Userid = secureLocalStorage.getItem("Userid");
    const PaymentId = sessionStorage.getItem("Paymentid") || "1";
    const txId = sessionStorage.getItem("transactionId") || transactionid || "";
    if (Userid) {
      const additionalPrice = selectPatient.length >= 2 && (selectPatient.length - 1) * extraPatientCharges;
      const TotalPrice = couponCode ? totalAmt2 - couponCode.amt : totalAmt2;
      const Data = {
        id: String(Userid),
        d_id: Daata?.Docid || docProfileData?.id || "23",
        sub_depar_id: Daata?.subdeparid || departmentData?.id || "106",
        hospital_id: Daata?.HospitalId || hospitalName?.id || departmentData?.hospital_id || "10",
        department_id: Daata?.DepartmentId || departmentData?.department_id || "18",
        date: Daata?.Date || new Date().toISOString().split("T")[0],
        date_type: Daata?.datetype || "Morning",
        time: Daata?.time || "10:00 AM",
        family_mem_id: selectPatient && selectPatient.length > 0 ? selectPatient : (familyData?.[0]?.id ? [familyData[0].id] : ["0"]),
        show_type: Daata?.show_type || "1",
        show_type_price: Daata?.showtypeprice || serviceTotal || "0",
        tot_price: TotalPrice,
        additional_price: additionalPrice ? String(additionalPrice) : "0",
        coupon_id: couponCode ? String(couponCode.id) : "",
        coupon_amount: couponCode ? String(couponCode.amt) : "0",
        doctor_commission: Daata?.commission || "0",
        site_commisiion: tax || "0",
        payment_id: String(PaymentId),
        wallet_amount: isDriverSelected ? String(wallet) : "0",
        additional_note: additionalNote ? additionalNote : "",
        transactionId: txId,
      };
      axios.post(`${ApiBaseUrl}/customer/book_appointment`, Data)
        .then((res) => {
          const { message, ResponseCode, appointment_id } = res.data;
          if (ResponseCode === 200) {
            HandleBookAppointGet(appointment_id);
            setIsPayment(false);
            showToast({ title: message, id: "success" });
            setIsBooking(true);
            sessionStorage.removeItem("transactionId");
          } else {
            showToast({ title: message || t("Booking Failed"), id: "error" });
          }
        })
        .catch((error) => {
          console.error(error);
          showToast({ title: error?.response?.data?.message || t("Booking Request Failed"), id: "error" });
        });
    }
  };

  useEffect(() => {
    const status = sessionStorage.getItem("Bookid");
    if (status) { HandleBookAppointGet(status); }
  }, []);

  const HandleBookAppointGet = (id) => {
    const Userid = secureLocalStorage.getItem("Userid");
    if (Userid) {
      axios.post(`${ApiBaseUrl}/customer/success_appo_detail`, { id: Userid, appointment_id: id })
        .then((res) => { setBookingData(res.data); sessionStorage.removeItem("Bookid"); })
        .catch((error) => { console.error(error); });
    }
  };

  useEffect(() => {
    loading ? document.body.style.overflow = "hidden" : document.body.style.overflow = "auto";
  }, [loading]);

  return (
    <div className="pb-[50px]">
      {loading
        ? <Loading CustomeStyle="fixed left-0 top-0 h-[100vh] w-full flex z-[999] items-center justify-center bg-white" />
        : (
          <div className="w-full width-container pb-[80px]">
            <div className="pt-6 book-appointment">

              {/* ── Breadcrumb ── */}
              <div className="flex items-center justify-between top-section gap-3 mb-6">
                <Link
                  to="/"
                  className="flex items-center gap-1.5 border-2 border-gray-200 rounded-full px-3 group py-1.5 hover:bg-black overflow-hidden shrink-0 transition-colors"
                >
                  <IoIosArrowBack className="group-hover:text-white shrink-0" />
                  <span className="font-medium text-sm group-hover:text-white whitespace-nowrap">{t("Go Home")}</span>
                </Link>
                <div className="flex items-center gap-2 overflow-hidden text-sm">
                  <Link to="/doctor-profile" className="font-medium text-slate-700 whitespace-nowrap truncate">{t("Doctor Profile")}</Link>
                  <IoIosArrowForward className="shrink-0 text-slate-400" />
                  <span className="font-medium text-slate-400 whitespace-nowrap truncate">{t("Book Appointment")}</span>
                </div>
              </div>

              {/* ── Main grid ── */}
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">

                {/* ─ Left column ─ */}
                <div className="flex flex-col gap-4">

                  {/* Doctor Card */}
                  <div className="bg-white rounded-2xl border border-slate-100 shadow-sm p-4 flex items-center gap-4">
                    <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-xl overflow-hidden bg-slate-100 shrink-0 shadow-sm">
                      <ImageLoad src={ImgBaseUrl + docProfileData?.logo} CustomeStyle="object-cover w-full h-full" alt="doctor" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <h3 className="font-bold text-slate-800 text-base sm:text-lg truncate">{docProfileData?.name}</h3>
                      <p className="text-sm text-indigo-600 font-medium truncate">{departmentData?.department_name}</p>
                      <div className="flex items-center gap-3 mt-1.5 text-xs text-slate-500 flex-wrap">
                        <span className="flex items-center gap-1 font-medium">
                          <FaStar className="text-orange-400 text-xs" />
                          {docProfileData?.avg_star}
                        </span>
                        <span className="flex items-center gap-1">
                          <span className="w-1 h-1 bg-slate-400 rounded-full" />
                          {docProfileData?.year_of_experience} {t("Years Experience")}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Appointment Details */}
                  <div className="bg-white rounded-2xl border border-slate-100 shadow-sm p-4">
                    <SectionLabel label={t("Appointment Details")} />
                    <div className="flex items-center gap-3 bg-slate-50 rounded-xl p-3">
                      <div className="w-14 h-14 sm:w-16 sm:h-16 rounded-xl overflow-hidden bg-slate-200 shrink-0">
                        <ImageLoad src={ImgBaseUrl + hospitalName?.image} CustomeStyle="w-full h-full object-cover" alt="hospital" />
                      </div>
                      <div className="flex-1 min-w-0">
                        <p className="font-bold text-slate-800 text-sm truncate">{t(Daata?.showtitle)}</p>
                        <p className="text-xs text-slate-500 truncate">{hospitalName?.name}</p>
                        <div className="flex items-center gap-2 mt-1 text-xs text-slate-400 flex-wrap">
                          <span className="flex items-center gap-1">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M3 7.5C3 5.29086 4.79086 3.5 7 3.5H17C19.2091 3.5 21 5.29086 21 7.5V18C21 20.2091 19.2091 22 17 22H7C4.79086 22 3 20.2091 3 18V7.5Z" stroke="#94a3b8" strokeWidth="1.5" />
                              <path d="M3 9H21" stroke="#94a3b8" strokeWidth="1.5" strokeLinecap="round" />
                              <path d="M8 2L8 5" stroke="#94a3b8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                              <path d="M16 2V5" stroke="#94a3b8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                              <circle cx="12" cy="15" r="1" fill="#94a3b8" />
                              <circle cx="16" cy="15" r="1" fill="#94a3b8" />
                              <circle cx="8" cy="15" r="1" fill="#94a3b8" />
                            </svg>
                            {split[2]}, {split[1]} {split[3]}
                          </span>
                          <span className="w-1 h-1 bg-slate-300 rounded-full" />
                          <span className="font-medium">{Daata?.time}</span>
                        </div>
                      </div>
                      <div className="shrink-0 text-right">
                        <p className="text-xs text-slate-400">{t("Fee")}</p>
                        <p className="font-bold text-slate-800 text-base">{Daata?.showtypeprice}{currency}</p>
                      </div>
                    </div>
                  </div>

                  {/* Select Patient */}
                  <div className="bg-white rounded-2xl border border-slate-100 shadow-sm p-4">
                    <SectionLabel label={t("Select Patient")} />
                    <Swiper
                      slidesPerView="auto"
                      spaceBetween={10}
                      modules={[Pagination]}
                      className="mySwiper"
                    >
                      <SwiperSlide
                        onClick={() => setIsPatient(true)}
                        className="add-box shrink-0 flex flex-col items-center justify-center gap-1 w-16 h-16 rounded-xl bg-indigo-50 border-2 border-dashed border-indigo-300 cursor-pointer hover:bg-indigo-100 transition-colors"
                      >
                        <LuPlus className="text-indigo-600 text-xl" />
                      </SwiperSlide>
                      {familyData?.map((item, index) => {
                        const isSelected = selectPatient.includes(item.id);
                        return (
                          <SwiperSlide
                            key={index}
                            onClick={() => SelectPatientHandle(item.id)}
                            className="patient-box !w-auto text-center cursor-pointer relative overflow-visible"
                          >
                            <ImageLoad
                              src={ImgBaseUrl + item.profile_image}
                              CustomeStyle={`patient-img ${isSelected ? "border-[3px] border-indigo-600" : ""}`}
                              alt="patient"
                            />
                            {isSelected && (
                              <div className="absolute right-[5px] bottom-[28px] p-[2px] rounded-full bg-white shadow-sm">
                                <div className="bg-indigo-600 rounded-full p-[2px]">
                                  <IoCheckmark className="text-white text-xs" />
                                </div>
                              </div>
                            )}
                            <h1 className="font-medium text-sm mt-1">{item.name}</h1>
                          </SwiperSlide>
                        );
                      })}
                    </Swiper>
                  </div>

                </div>

                {/* ─ Right column ─ */}
                <div className="flex flex-col gap-4">

                  {/* Message */}
                  <div className="bg-white rounded-2xl border border-slate-100 shadow-sm p-4">
                    <SectionLabel label={t("Message")} />
                    <textarea
                      onChange={(e) => setAdditionalNote(e.target.value)}
                      className="w-full textarea focus-within:border-indigo-500 border-2 border-slate-100 rounded-xl resize-none text-sm p-3 text-slate-700 placeholder-slate-400 focus:outline-none transition-colors"
                      placeholder={t("Message")}
                    />
                  </div>

                  {/* Wallet */}
                  {Number(myWallet) > 0 && (
                    <div className="bg-white rounded-2xl border border-slate-100 shadow-sm p-4">
                      <div className="flex items-center justify-between mb-3">
                        <SectionLabel label={t("Pay from Wallet")} />
                        <label className="switch2 shrink-0">
                          <input type="checkbox" checked={isDriverSelected} onChange={toggleDriverSelection} />
                          <span className="slider round" />
                        </label>
                      </div>
                      <div className="flex items-center justify-between bg-indigo-50 border border-indigo-100 rounded-xl px-4 py-3">
                        <div className="flex items-center gap-2">
                          <LuWallet className="text-indigo-600 text-lg" />
                          <span className="font-semibold text-slate-700 text-sm">{t("My Wallet")}</span>
                        </div>
                        <span className="font-bold text-indigo-600 text-base">
                          {currency}{isDriverSelected ? myWallet2 : myWallet}
                        </span>
                      </div>
                    </div>
                  )}

                  {/* Coupon */}
                  {couponList.length >= 1 && (
                    <div className="bg-white rounded-2xl border border-slate-100 shadow-sm p-4">
                      <div className="flex items-center justify-between pb-3 border-b border-slate-100">
                        <div className="flex items-center gap-2">
                          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="#4338ca" stroke="none">
                            <path d="M12.01 2.011c.852 0 1.668 .34 2.267 .942l.698 .698a1.2 1.2 0 0 0 .845 .349h1a3.2 3.2 0 0 1 3.2 3.2v1c0 .316 .126 .62 .347 .843l.698 .698a3.2 3.2 0 0 1 .002 4.536l-.698 .698a1.2 1.2 0 0 0 -.349 .845v1a3.2 3.2 0 0 1 -3.2 3.2h-1a1.2 1.2 0 0 0 -.843 .347l-.698 .698a3.2 3.2 0 0 1 -4.536 .002l-.698 -.698a1.2 1.2 0 0 0 -.845 -.349h-1a3.2 3.2 0 0 1 -3.2 -3.2v-1a1.2 1.2 0 0 0 -.347 -.843l-.698 -.698a3.2 3.2 0 0 1 -.002 -4.536l.698 -.698a1.2 1.2 0 0 0 .349 -.845v-1l.005 -.182a3.2 3.2 0 0 1 3.195 -3.018h1a1.2 1.2 0 0 0 .843 -.347l.698 -.698a3.2 3.2 0 0 1 2.269 -.944m2.49 10.989a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3m1.207 -4.707a1 1 0 0 0 -1.414 0l-6 6a1 1 0 0 0 1.414 1.414l6 -6a1 1 0 0 0 0 -1.414m-6.207 -.293a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3" />
                          </svg>
                          <div>
                            <p className="font-bold text-indigo-700 text-sm">{t("Apply Coupon")}</p>
                            {couponCode && <span className="text-xs text-slate-500">{t("Use Code")}: <span className="font-bold text-indigo-600">{couponCode.code}</span></span>}
                          </div>
                        </div>
                        <button
                          onClick={HandleCoupanRemove}
                          className={`text-sm font-bold px-3 py-1 rounded-lg transition-colors ${couponCode ? "bg-red-50 text-red-500 hover:bg-red-100" : "bg-indigo-50 text-indigo-600 hover:bg-indigo-100"}`}
                        >
                          {couponCode ? t("Remove") : t("Apply")}
                        </button>
                      </div>
                      <div
                        onClick={() => !couponCode && setIsCouponShow(true)}
                        className="flex items-center justify-between pt-3 cursor-pointer"
                      >
                        <span className="text-sm text-slate-400">{t("View All Coupons")}</span>
                        <LuChevronRight className="text-slate-400 text-lg" />
                      </div>
                    </div>
                  )}

                  {/* Bill Summary */}
                  <div className="bg-white rounded-2xl border border-slate-100 shadow-sm p-4">
                    <SectionLabel label={t("Review Your Requirements for This Request")} />
                    <div className="bg-slate-50 rounded-xl px-4 py-3">
                      <PriceRow label={t("Service Total")} value={`${currency}${serviceTotal}.00`} />
                      {isDriverSelected && <PriceRow label={t("Wallet")} value={`-${currency}${Number(wallet).toFixed(0)}`} accent />}
                      {couponCode && <PriceRow label={t("Coupon")} value={`${currency}-${couponCode.amt}`} accent />}
                      <PriceRow label={`${t("Service Fee & Tax")} (${taxType})`} value={`+${currency}${tax}`} />
                      {selectPatient.length >= 2 && (
                        <PriceRow label={`${t("Additional Patient Charge")} ($${extraPatientCharges})`} value={`+${currency}${extraPatientCharges}`} />
                      )}
                      <div className="flex items-center justify-between pt-3 mt-1 border-t border-slate-200">
                        <span className="font-bold text-slate-800 text-sm">{t("Total Payable Amount")}</span>
                        <span className="font-extrabold text-indigo-700 text-base">{totalAmt.toFixed(2)}{currency}</span>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        )}

      {/* ── Fixed bottom Proceed bar ── */}
      {!loading && (
        <div className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-slate-100 shadow-lg px-4 py-3">
          <div className="max-w-5xl mx-auto flex items-center justify-between gap-4">
            <div>
              <p className="text-xs text-slate-400">{t("Total")}</p>
              <p className="font-extrabold text-slate-800 text-lg leading-tight">{currency}{totalAmt?.toFixed(2)}</p>
              <span className="text-xs text-indigo-600 font-medium cursor-pointer hover:underline">{t("View Detailed Bill")}</span>
            </div>
            <button
              onClick={HandleProceed}
              className="bg-indigo-600 hover:bg-indigo-700 active:scale-[0.98] text-white font-bold text-sm px-8 py-3 rounded-2xl transition-all duration-200 uppercase tracking-wide min-w-[140px]"
            >
              {t("Proceed")}
            </button>
          </div>
        </div>
      )}

      {/* ── Add Patient Modal ── */}
      {isPatient && (
        <div onClick={() => setIsPatient(false)} className="flex bg-slate-900/60 backdrop-blur-sm h-full justify-center w-full fixed items-end left-0 top-0 z-[999]">
          <div onClick={(e) => e.stopPropagation()} className="add-patient w-full max-w-2xl rounded-t-3xl bg-white p-5 max-h-[90vh] overflow-y-auto scroll-container">
            <AddPatient Relation={relationshipData} BooldType={booldData} />
          </div>
        </div>
      )}

      {/* ── Coupon Modal ── */}
      {isCouponShow && (
        <div onClick={() => setIsCouponShow(false)} className="flex bg-slate-900/60 backdrop-blur-sm h-full justify-center w-full fixed items-center left-0 top-0 z-[999] p-4">
          <div onClick={(e) => e.stopPropagation()} className="bg-white rounded-2xl shadow-2xl w-full max-w-md max-h-[600px] overflow-y-auto scroll-container p-5">
            <h2 className="font-bold text-lg text-slate-800 mb-4">{t("Best Coupon")}</h2>
            <div className="flex flex-col gap-3">
              {couponList.map((item, index) => (
                <div key={index} className="border border-slate-100 bg-slate-50 rounded-2xl p-4 flex items-start justify-between gap-3">
                  <div className="flex-1 min-w-0">
                    <h3 className="font-bold text-slate-800 text-base">{item.title}</h3>
                    <p className="text-sm text-slate-500 mt-0.5">{item.sub_title}</p>
                    <div className="mt-2 space-y-0.5 text-sm text-slate-600">
                      <p>{t("Coupon Code")}: <span className="font-bold text-indigo-600">{item.code}</span></p>
                      <p>{t("Coupon Amount")}: <span className="font-bold">{currency}{item.discount_amount}</span></p>
                      <p>{t("Minimum Amount")}: <span className="font-medium">{currency}{item.min_amount}</span></p>
                      <p>{t("Ex Date")}: <span className="font-medium">{item.end_date}</span></p>
                    </div>
                    <button
                      onClick={() => HandleCoupanAdd(item.code, item.discount_amount, item.id)}
                      disabled={totalAmt < item.min_amount}
                      className={`mt-3 text-sm font-bold px-4 py-2 rounded-xl transition-all ${totalAmt > item.min_amount ? "bg-indigo-600 text-white hover:bg-indigo-700" : "bg-slate-200 text-slate-400 cursor-not-allowed"}`}
                    >
                      {t("Apply Coupon")}
                    </button>
                  </div>
                  <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 24 24" fill="#f97316" stroke="none" className="shrink-0 mt-1">
                    <path d="M12.01 2.011c.852 0 1.668 .34 2.267 .942l.698 .698a1.2 1.2 0 0 0 .845 .349h1a3.2 3.2 0 0 1 3.2 3.2v1c0 .316 .126 .62 .347 .843l.698 .698a3.2 3.2 0 0 1 .002 4.536l-.698 .698a1.2 1.2 0 0 0 -.349 .845v1a3.2 3.2 0 0 1 -3.2 3.2h-1a1.2 1.2 0 0 0 -.843 .347l-.698 .698a3.2 3.2 0 0 1 -4.536 .002l-.698 -.698a1.2 1.2 0 0 0 -.845 -.349h-1a3.2 3.2 0 0 1 -3.2 -3.2v-1a1.2 1.2 0 0 0 -.347 -.843l-.698 -.698a3.2 3.2 0 0 1 -.002 -4.536l.698 -.698a1.2 1.2 0 0 0 .349 -.845v-1l.005 -.182a3.2 3.2 0 0 1 3.195 -3.018h1a1.2 1.2 0 0 0 .843 -.347l.698 -.698a3.2 3.2 0 0 1 2.269 -.944m2.49 10.989a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3m1.207 -4.707a1 1 0 0 0 -1.414 0l-6 6a1 1 0 0 0 1.414 1.414l6 -6a1 1 0 0 0 0 -1.414m-6.207 -.293a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3" />
                  </svg>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* ── Payment Modal ── */}
      {isPayment && (
        <div onClick={() => setIsPayment(false)} className="flex bg-slate-900/60 backdrop-blur-sm h-full justify-center w-full fixed items-center left-0 top-0 z-[999] p-4 animate-fade-in">
          <div onClick={(e) => e.stopPropagation()} className="bg-white rounded-3xl p-6 shadow-2xl max-w-md w-full max-h-[85vh] flex flex-col gap-2 relative overflow-hidden">
            <h2 className="font-bold text-lg text-slate-800">{t("Select Payment Method")}</h2>
            <Payment Amount={totalAmt} Data={allData} INDEX={Daata?.show_type === "2" && 16} />
          </div>
        </div>
      )}

      {/* ── Booking Success Modal ── */}
      {isBooking && (
        <div className="flex bg-slate-900/60 backdrop-blur-sm h-full justify-center w-full fixed items-center left-0 top-0 z-[999] p-4">
          <div className="bottme-box bg-white rounded-2xl shadow-2xl w-full max-w-lg">
            <BookingDetails Data={bookingData} />
          </div>
        </div>
      )}

    </div>
  );
};

export default Bookappoinment;
/* jshint ignore:end */